import { FlexColumn, FlexRow } from '@gorila-shared-ui/components';
import { Modal, ModalBody, ModalHeader } from 'baseui/modal';
import { memo } from 'react';
import { createPortal } from 'react-dom';
import { FLEET_JOB_TYPE_LABELS } from '../../../../constants/fleet';
import { useStyles } from '../../../../hooks/useStyles';
import { FleetAsset, FleetJobType, FleetService } from '../../../../types/fleet';
import FleetAssetInlineLabel from '../../shared/FleetAssetInlineLabel';
import { FleetServiceJobForm } from './FleetServiceJobForm';

type Props = {
  isOpen: boolean;
  jobType: FleetJobType;
  onClose: (update?: boolean) => void;
  selectedAsset?: FleetAsset;
  selectedService?: FleetService;
};

function FleetServiceJobModal({ jobType, selectedAsset, onClose, isOpen, selectedService }: Props) {
  const { css } = useStyles();

  return createPortal(
    <Modal
      animate
      closeable
      onClose={() => onClose()}
      isOpen={isOpen}
      size="auto"
      autoFocus={false}
    >
      <FlexRow
        gap={0}
        classNames={css({
          justifyContent: 'space-between',
          margin: '6px 2rem 0px 0px',
        })}
      >
        <ModalHeader
          className={css({
            marginBottom: '0 !important',
          })}
        >
          Registro de {FLEET_JOB_TYPE_LABELS[jobType].toLowerCase()}
        </ModalHeader>
      </FlexRow>
      <ModalBody>
        <FlexColumn
          classNames={css({
            width: '70vw',
            maxWidth: '600px',
            minWidth: '350px',
            boxSizing: 'border-box',
            padding: '1rem',
            borderTop: '1px solid rgb(226, 226, 226)',
            maxHeight: '80vh',
          })}
        >
          {selectedAsset && <FleetAssetInlineLabel asset={selectedAsset} />}
          <FleetServiceJobForm
            assetId={selectedAsset?._id}
            jobType={jobType}
            serviceId={selectedService?._id}
            onCancel={() => onClose(false)}
            afterSave={() => onClose(true)}
            lastMaintenance={selectedAsset?.lastMaintenance}
          />
        </FlexColumn>
      </ModalBody>
    </Modal>,
    document.body,
  );
}

export default memo(FleetServiceJobModal);
